/* ===========================================================================
   OUR PUBLISHING PROCESS — behaviour.
   SOURCE OF TRUTH: design-system/ui_kits/website/process.html, the LAST
   <script> block, verbatim. Every routine is scoped to .tws-proc, so the
   header, footer and any Dawn component on the page are untouched, and each
   one no-ops when its section is absent — the file is safe to load on a page
   that renders only some of the process sections.
   =========================================================================== */
/* ══════════════════════════════════════════════════════════════════════
   Our Publishing Process — vanilla port of the handoff's DCLogic class.
   Same behaviour, no framework. Everything is scoped to .tws-proc so the
   locked chrome / authors / footer are never touched.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  var TITLES = ['Author registration','Manuscript review','Choosing your package','The agreement','Editorial & design','Printing','Launch & distribution','After publication'];
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* Both reveal mechanisms below make content invisible first and animate it
     back. Under "Reduce motion" the animation never runs, so they are skipped
     entirely rather than left holding the content hidden. */
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- headline type: every word rises out of its own mask ---- */
  function splitWords() {
    var heads = $$('.tws-proc h1, .tws-proc h2, .tws-proc h3');
    var wrap = function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'sw';
            var i = document.createElement('i'); i.textContent = p;
            s.appendChild(i); frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' &&
                   n.tagName !== 'BUTTON' && n.tagName !== 'A') { wrap(n); }
      });
    };
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 52) + 'ms'; });
      };
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ---- reveals: only what starts below the fold is hidden ---- */
  function initReveal() {
    if (REDUCE) return;                       // leave everything visible
    var els = $$('.tws-proc [data-rv]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var kind = el.getAttribute('data-rv') || 'rise';
        var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
        el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight * 0.88) { el.style.opacity = '0'; io.observe(el); }
    });
  }

  /* ---- the week ruler draws its bars, staggered ---- */
  function initBars() {
    var rows = $$('.tws-proc .bar-fill');
    if (!rows.length || typeof IntersectionObserver === 'undefined') { rows.forEach(function (r) { r.classList.add('on'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        en.target.style.transitionDelay = (parseInt(en.target.getAttribute('data-d') || '0', 10)) + 'ms';
        en.target.classList.add('on');
      });
    }, { threshold: 0.3 });
    rows.forEach(function (r) { io.observe(r); });
  }

  /* ---- package tabs: switching replays the bars ---- */
  function initTlTabs() {
    var wrap = $('#timeline');
    if (!wrap) return;
    var tabs = $$('.tl-tab', wrap), panels = $$('.tl-panel', wrap);
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var show = function (id, replay) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.tab === id)); });
      panels.forEach(function (p) {
        var on = p.dataset.pkg === id;
        p.classList.toggle('on', on);
        if (!on || !replay) return;
        var fills = $$('.bar-fill', p);
        if (reduce) { fills.forEach(function (f) { f.classList.add('on'); }); return; }
        fills.forEach(function (f) { f.classList.remove('on'); });
        void p.offsetWidth;
        fills.forEach(function (f) {
          f.style.transitionDelay = (parseInt(f.getAttribute('data-d') || '0', 10)) + 'ms';
          f.classList.add('on');
        });
      });
      /* MOBILE — the tab strip is a horizontal scroller below 860px, so the tab
         just chosen can sit off-screen. Centre it with scrollLeft, never
         scrollIntoView(), which would also scroll the page. */
      var strip = $('.tl-tabs-in', wrap), t = tabs.filter(function (x) { return x.dataset.tab === id; })[0];
      if (strip && t && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
      }
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.tab, true); }); });
    show('standard', false);
  }

  /* ---- the author checklist ticks itself as you reach it ---- */
  function initChecks() {
    var rows = $$('.tws-proc .ck-row');
    if (!rows.length || typeof IntersectionObserver === 'undefined') { rows.forEach(function (r) { r.classList.add('on'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        setTimeout(function () { en.target.classList.add('on'); }, Math.max(0, rows.indexOf(en.target)) * 110);
      });
    }, { threshold: 0.45 });
    rows.forEach(function (r) { io.observe(r); });
  }

  /* ---- one rAF loop: the stage spine that draws itself, plus parallax ----
     The handoff also drove a scroll-progress rail inside its own header; this
     page uses the locked site header, so that bit is gone. */
  function initScrollFX() {
    var rowsWrap = $('#sgRows'), fill = $('#sgFill'), numEl = $('#sgNum'), titleEl = $('#sgTitle');
    var rows = rowsWrap ? $$('.sg-row', rowsWrap) : [];
    var pars = $$('.tws-proc [data-par]');
    var lastActive = -1;
    var apply = function () {
      if (rowsWrap && fill && rows.length) {
        var r = rowsWrap.getBoundingClientRect();
        var span = Math.max(1, r.height - 32);
        var h = Math.max(0, Math.min(span, innerHeight * 0.5 - (r.top + 16)));
        fill.style.height = h.toFixed(1) + 'px';
        var active = -1, i;
        for (i = 0; i < rows.length; i++) {
          if (rows[i].getBoundingClientRect().top < innerHeight * 0.55) active = i;
        }
        if (active !== lastActive) {
          rows.forEach(function (el, i) { if (i <= active) el.classList.add('on'); else el.classList.remove('on'); });
          if (numEl) numEl.textContent = active >= 0 ? '0' + (active + 1) : '01';
          if (titleEl) {
            /* the name now lives on the row (data-short), set from each stage's
               "Short name" field, so adding or reordering stages just works.
               TITLES stays only as a fallback for a block left blank. */
            var ti = active >= 0 ? active : 0;
            var shortName = rows[ti] && rows[ti].getAttribute('data-short');
            titleEl.textContent = shortName || TITLES[ti] || '';
          }
          lastActive = active;
        }
      }
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > innerHeight + 240) return;
        var c = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        var amt = parseFloat(el.getAttribute('data-par')) || 0;
        el.style.setProperty('--py', (-c * amt * 100).toFixed(1) + 'px');
      });
    };
    var queued = false;
    var run = function () { queued = false; try { apply(); } catch (e) {} };
    var onScroll = function () { if (queued) return; queued = true; requestAnimationFrame(run); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(run, 260);
    run();
  }

  /* ---- packages: details typeset line by line, hairlines draw themselves ----
     Re-queried every tick: a mount-time snapshot precedes layout. */
  function initPackages() {
    var root = $('#cost');
    if (!root || REDUCE) return;              // never hide what cannot animate back
    root.classList.add('pk-anim');
    var light = function (el, i) {
      if (el.classList.contains('on')) return;
      if (el.classList.contains('ln')) el.style.animationDelay = (i * 46) + 'ms';
      el.classList.add('on');
    };
    var sweep = function () {
      var live = $$('.ln:not(.on), .rl-x:not(.on), .rl-y:not(.on)', root);
      if (!live.length) return;
      var seen = new Map();
      live.forEach(function (el) {
        if (el.getBoundingClientRect().top > innerHeight * 0.96) return;
        var key = el.parentNode, i = (seen.get(key) || 0);
        seen.set(key, i + 1);
        light(el, i);
      });
    };
    var q = false;
    var onScroll = function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; sweep(); }); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(sweep, 300);
    requestAnimationFrame(sweep);
  }

  /* ---- FAQ: one open at a time ---- */
  function initFaq() {
    var faqs = $$('#faq details.faq');
    /* The first card no longer opens itself (user decision, 8 Aug 2026).
       `if (faqs[0]) faqs[0].open = true;` used to sit here and overrode the
       markup, so deleting the `open` attribute alone did nothing. The
       toggle listener below still closes the others. */
    faqs.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        faqs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---- in-page jumps from the hero contents rail ---- */
  function initGoto() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-goto]') : null;
      if (!t) return;
      e.preventDefault();
      var el = document.getElementById(t.getAttribute('data-goto'));
      if (!el) return;
      scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + scrollY - 130), behavior: 'smooth' });
    });
  }

  /* ---- MOBILE — keep each ⓘ popover inside the viewport ----
     The panel is anchored to its trigger, so on a narrow column it can hang off
     any edge, and the design only ever opens it upward. Re-anchor on BOTH axes:
     prefer above the trigger, fall back to below, otherwise clamp into view.
     Runs on hover AND focus, so it covers the tap path too, where :focus-within
     is the only thing that opens the panel. Never nudge it with `transform` —
     the open animation owns that property. */
  function initPops() {
    var clear = function (p) { p.style.left = p.style.right = p.style.top = p.style.bottom = ''; };
    var place = function (ip) {
      var pop = ip.querySelector('.pop');
      if (!pop) return;
      clear(pop);                                          // back to the authored anchor
      var host = ip.getBoundingClientRect();
      var w = pop.offsetWidth, h = pop.offsetHeight, pad = 12;

      var natL = pop.getBoundingClientRect().left;
      var wantL = Math.max(pad, Math.min(natL, innerWidth - pad - w));

      var above = host.top - 11 - h, below = host.bottom + 11, wantT;
      if (above >= pad) wantT = above;
      else if (below + h <= innerHeight - pad) wantT = below;
      else wantT = Math.max(pad, Math.min(innerHeight - pad - h, host.top - h / 2));

      pop.style.left = (wantL - host.left) + 'px';
      pop.style.right = 'auto';
      pop.style.top = (wantT - host.top) + 'px';
      pop.style.bottom = 'auto';
      /* the open animation scales from a corner — point it at the edge the card
         actually grew from, or it appears to fly in from the wrong side */
      pop.style.transformOrigin = (wantT < host.top ? 'bottom ' : 'top ') +
                                  (wantL + w / 2 < host.left ? 'right' : 'left');
    };
    var pops = $$('.tws-proc .ipop');
    pops.forEach(function (ip) {
      ip.addEventListener('pointerenter', function () { place(ip); });
      ip.addEventListener('focusin', function () { place(ip); });
    });
    addEventListener('resize', function () {
      pops.forEach(function (ip) { var p = ip.querySelector('.pop'); if (p) clear(p); });
    }, { passive: true });
  }

  function init() {
    splitWords(); initReveal(); initBars(); initTlTabs(); initChecks();
    initScrollFX(); initPackages(); initFaq(); initGoto(); initPops();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
